import { render } from "./BaseLoadingBar.vue?vue&type=template&id=f3f2a738"
const script = {}

import "./BaseLoadingBar.vue?vue&type=style&index=0&id=f3f2a738&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__